import { useSelector } from 'react-redux';
import { getSid } from '@client/context/redux/redux';

export const useSid = (): string => useSelector(getSid);

